// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"3c02ecc4","220":"d3385266","830":"85059999","960":"66c575de","981":"b2fc2eb8"}[chunkId] + ".chunk.css";
};